import { Component, Input } from '@angular/core';
import { CategoriesProvider } from '../../providers/categories/categories';
import { NavController } from 'ionic-angular';
import { Category } from '../../interfaces/category.model';
import { SubcategoriesPage } from '../../pages/subcategories/subcategories';


@Component({
  selector: 'category',
  templateUrl: 'category.html'
})
export class CategoryComponent {

  @Input() category: Category;
  @Input() displaylist: boolean;

  constructor(public navCtrl: NavController, public categoriesService: CategoriesProvider) {
  }

  showSubCategory(category){
    this.navCtrl.push(SubcategoriesPage, {category: category});
  }

  displayAssetLabel(){
    let assetText = "assets";
    if(this.category.totalAssets && this.category.totalAssets == 1){
       assetText = "asset";
    } else {
      assetText = "assets";
    }
    return assetText;
  }

  setCategoryClass(category){
    let catClass = "";

    if(category.ParentCategoryId != null){
      return false;
    } 
    else {
      switch(category.CategoryIndex){
        case 1:
            catClass = "order";
        break;
        case 2:
            catClass = "training";
        break;
        case 3:
            catClass = "service-material";
        break;
        case 4:
            catClass = "product-meeting";
        break;
        case 5:
            catClass = "product-general";
        break;
        case 6:
            catClass = "corporate";
        break;
        case 7:
            catClass = "news";
        break;
        case 8:
            catClass = "worksheets";
        break;
        case 9:
            catClass = "substitution";
        break;
        case 10:
            catClass = "education";
        break;
      }
      return catClass;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/category/category.ts